import { IconCircleXFilled, IconAlertCircle } from '@tabler/icons-react'
import { Modal, Space, Spin } from 'antd'
import { useUserSocket } from 'app/hooks/trade/userSocket'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import {
	ContentContainer,
	ContentWrapper,
} from '../../styles/globalPage-styles'
import { View } from '../../styles/reactnative'
import { ThemeContext } from '../../theme/ThemeProvider'
import { useMobileDimensions, useToken } from '../hooks'
import { useLogQueue } from '../hooks/trade/logQueue'
import { useTradeModalStore } from '../hooks/trade/modalStore'
import { useOrderStore } from '../hooks/trade/orderStore'
import { useTradePosition } from '../hooks/trade/tradePosition'
import { Header } from '../organisms'

const Logout = ({ }: any) => {
	const { t } = useTranslation()
	const { data: token, mutate } = useToken()
	const [islogout, setislogout] = useState(false)
	const { mutate: mutateModalStore } = useTradeModalStore()
	const { reset } = useOrderStore()
	const { reset: resPos } = useTradePosition()
	const { leaveGroup } = useUserSocket()

	const { isMobile } = useMobileDimensions()

	const { mutate: mutateLog } = useLogQueue()

	const msg = window.location.href.split('?msg=')[1]

	useEffect(() => {
		localStorage.removeItem('app-cache')
		leaveGroup();
		reset()
		resPos()

		mutateLog({
			log: 'HM999',
			data: {
				isMobile: isMobile,
			},
		})

		mutate(null).then(() => {
			leaveGroup();
			reset()
			resPos()
			mutateModalStore(null)
		})

		setTimeout(() => {
			leaveGroup();
			reset()
			resPos()
			mutateModalStore(null)
		}, 500)

		if (islogout) {
			if (token) {
				mutate(null)
			}
			setTimeout(() => {
				window.location.href = '/'
			}, 1500)

			setislogout(false)
		} else {
			setTimeout(() => {
				window.location.href = '/'
			}, 1500)
		}
	}, [])

	const { isDarkMode, theme } = useContext(ThemeContext)
	return (
		<LogoutContainer isDarkMode={isDarkMode}>
			<Header />
			<LogoutContent>
				<LogoutCard isDarkMode={isDarkMode}>
					<IconWrapper isDarkMode={isDarkMode}>
						<IconAlertCircle size={80} stroke={1.5} color={theme.COLORS.point} />
					</IconWrapper>

					<Title style={{ color: theme.COLORS.textw }}>
						{t('SESSIONEXPIRE')}
					</Title>

					<Description style={{ color: theme.COLORS.textsilver }}>
						{t('SESSIONEXPIREDESC')}
					</Description>

					{msg && (
						<MessageBox isDarkMode={isDarkMode}>
							{decodeURI(msg)}
						</MessageBox>
					)}

					<LoadingSection>
						<Spin size="large" />
						<RedirectText style={{ color: theme.COLORS.textsilver }}>
							로그인 페이지로 이동 중...
						</RedirectText>
					</LoadingSection>
				</LogoutCard>
			</LogoutContent>
		</LogoutContainer>
	)
}

const LogoutContainer = styled.div<{ isDarkMode?: boolean }>`
	width: 100%;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	background: ${props => !props.isDarkMode
		? `radial-gradient(ellipse at top, ${props.theme.COLORS.point}15 0%, transparent 50%), radial-gradient(ellipse at bottom, ${props.theme.COLORS.point}10 0%, transparent 50%), ${props.theme.COLORS.background}`
		: `radial-gradient(ellipse at top, ${props.theme.COLORS.point}08 0%, transparent 60%), radial-gradient(ellipse at bottom, ${props.theme.COLORS.point}05 0%, transparent 60%), ${props.theme.COLORS.background}`
	};

	/* 떠다니는 배경 파티클 */
	&::before,
	&::after {
		content: '';
		position: absolute;
		border-radius: 50%;
		background: ${props => props.theme.COLORS.point};
		opacity: 0.06;
		animation: float 20s infinite ease-in-out !important;
		z-index: 0;
		pointer-events: none;
	}

	&::before {
		width: 400px;
		height: 400px;
		top: 10%;
		left: 5%;
		animation-delay: 0s !important;
	}

	&::after {
		width: 500px;
		height: 500px;
		bottom: 10%;
		right: 5%;
		animation-delay: 10s !important;
		animation-duration: 25s !important;
	}

	@keyframes float {
		0%, 100% {
			transform: translate(0, 0) scale(1);
		}
		33% {
			transform: translate(60px, -60px) scale(1.1);
		}
		66% {
			transform: translate(-40px, 40px) scale(0.9);
		}
	}
`

const LogoutContent = styled.div`
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 40px 20px;
	position: relative;
	z-index: 1;
`

const LogoutCard = styled.div<{ isDarkMode?: boolean }>`
	background: ${props => !props.isDarkMode
		? 'rgba(20, 20, 20, 0.8)'
		: 'rgba(255, 255, 255, 0.95)'};
	backdrop-filter: blur(20px);
	border-radius: 24px;
	padding: 60px 50px;
	max-width: 500px;
	width: 100%;
	box-shadow: ${props => !props.isDarkMode
		? `0 20px 60px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.1)`
		: `0 20px 60px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05)`};
	animation: fadeInScale 0.5s cubic-bezier(0.4, 0, 0.2, 1) !important;
	text-align: center;

	@keyframes fadeInScale {
		from {
			opacity: 0;
			transform: scale(0.9) translateY(20px);
		}
		to {
			opacity: 1;
			transform: scale(1) translateY(0);
		}
	}

	@media (max-width: 600px) {
		padding: 40px 30px;
	}
`

const IconWrapper = styled.div<{ isDarkMode?: boolean }>`
	width: 120px;
	height: 120px;
	margin: 0 auto 30px;
	border-radius: 50%;
	background: ${props => props.theme.COLORS.point}15;
	display: flex;
	align-items: center;
	justify-content: center;
	animation: pulse 2s ease-in-out infinite !important;

	@keyframes pulse {
		0%, 100% {
			transform: scale(1);
			box-shadow: 0 0 0 0 ${props => props.theme.COLORS.point}40;
		}
		50% {
			transform: scale(1.05);
			box-shadow: 0 0 0 20px ${props => props.theme.COLORS.point}00;
		}
	}
`

const Title = styled.h1`
	font-size: 28px;
	font-weight: 700;
	margin: 0 0 16px 0;

	@media (max-width: 600px) {
		font-size: 24px;
	}
`

const Description = styled.p`
	font-size: 16px;
	line-height: 1.6;
	margin: 0 0 24px 0;
	opacity: 0.8;

	@media (max-width: 600px) {
		font-size: 15px;
	}
`

const MessageBox = styled.div<{ isDarkMode?: boolean }>`
	background: ${props => !props.isDarkMode
		? 'rgba(255, 255, 255, 0.05)'
		: 'rgba(0, 0, 0, 0.05)'};
	border: 1px solid ${props => !props.isDarkMode
		? 'rgba(255, 255, 255, 0.1)'
		: 'rgba(0, 0, 0, 0.1)'};
	border-radius: 12px;
	padding: 16px 20px;
	margin-bottom: 24px;
	font-size: 14px;
	color: ${props => props.theme.COLORS.textsilver};
	word-break: break-word;
`

const LoadingSection = styled.div`
	margin-top: 40px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;
`

const RedirectText = styled.div`
	font-size: 14px;
	opacity: 0.7;
`

export default Logout
